import {
  Button,
  Card, DatePicker, Divider, Select,
  Typography
} from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import './index.scss';
import { sampleType } from 'common/assets/dummyData/system';
import { DropdownElement } from 'common/components/DropdownType';
import { formatDateYYYYMMDD } from 'common/utils/functions';

interface KioskDashboardFilterProps {
  isBlue?: boolean;
  typeParam: number | undefined;
  setTypeParam: (val: number | undefined) => void;
  kiosGroupId: number[];
  setKiosGroupId: (val: number[]) => void;
  dateRange: string[];
  setDateRange: (val: string[]) => void;
  onClear: () => void;
  onRefetch?: () => void;
  onRefetch2?: () => void;
  onRefetch3?: () => void;
  onRefetch4?: () => void;
  onRefetch5?: () => void;
  onRefetch6?: () => void;
}

const KioskDashboardFilter = ({
  isBlue,
  typeParam,
  setTypeParam,
  kiosGroupId,
  setKiosGroupId,
  dateRange,
  setDateRange,
  onClear,
  onRefetch,
  onRefetch2,
  onRefetch3,
  onRefetch4,
  onRefetch5,
  onRefetch6,
}: KioskDashboardFilterProps) => {
  const { t } = useTranslation();

  return (
    <Card size="small" className="o-kioskDashboardFilter">
      <div className="o-kioskDashboardFilter_wrapper">
        <div className="o-kioskDashboardFilter_item">
          <Typography.Text className="o-kioskDashboardFilter_label">{t('dashboard.chooseDate')}</Typography.Text>
          <DatePicker.RangePicker
            value={dateRange.length
              ? [moment(dateRange[0]), moment(dateRange[1])] : undefined}
            size="large"
            style={{ width: '100%' }}
            placeholder={[t('dashboard.startDatePlaceholder'), t('dashboard.endDatePlaceholder')]}
            separator={<Divider style={{ margin: 0, width: 30, borderTop: '1px solid #8A94A6' }} />}
            onChange={(val) => {
              if (!val) {
                setDateRange([]);
                return;
              }
              const res = val.map((item) => (formatDateYYYYMMDD(item)));
              setDateRange(res);
            }}
          />
        </div>
        <div className="o-kioskDashboardFilter_item">
          <Typography.Text className="o-kioskDashboardFilter_label">{t('dashboard2025.evaluateChannel')}</Typography.Text>
          <Select
            size="large"
            value={typeParam}
            placeholder={t('system.all')}
            style={{ width: '100%' }}
            onChange={(val) => setTypeParam(val)}
          >
            {
              sampleType.map((item, idx) => (
                <Select.Option
                  key={`${item.value}-${idx.toString()}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))
            }
          </Select>
        </div>
        <div className="o-kioskDashboardFilter_item">
          <Typography.Text className="o-kioskDashboardFilter_label">{t('dashboard.kioskGroup')}</Typography.Text>
          <DropdownElement
            type="kioskGroup"
            locale="vi"
            placeholder={t('system.all')}
            value={kiosGroupId}
            isShowSearch
            size="large"
            onChange={(val) => setKiosGroupId(val)}
            multiple={{ allowClear: true }}
          />
        </div>
        <div className="o-kioskDashboardFilter_actions">
          <Button
            onClick={onClear}
            type="primary"
            size="large"
            className={`o-kioskDashboardFilter_button${isBlue ? ' blue' : ''}`}
            disabled={!dateRange.length && !typeParam && !kiosGroupId.length}
          >
            {t('dashboard.deleteAll')}
          </Button>
          <Button
            onClick={() => {
              onRefetch?.();
              onRefetch2?.();
              onRefetch3?.();
              onRefetch4?.();
              onRefetch5?.();
              onRefetch6?.();
            }}
            type="primary"
            size="large"
            className={`o-kioskDashboardFilter_button${isBlue ? ' blue' : ''}`}
          >
            {t('dashboard.applyAll')}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default KioskDashboardFilter;
